<template>
  <v-autocomplete
  v-model="selection"
  :id="elementId"
  :label="label"
  :multiple="multiple"
  :chips="multiple"
  :deletable-chips="multiple"
  :clearable="true"
  :items="diameterGroups"
  :disabled="!(diameterGroups?.length > 0)"
  :prepend-icon="IconHelpers.getIconForObjectType('diameterGroup')"
  :error-messages="errorMessages"
  item-value="label"
  item-text="label"
  return-object
  @change="diameterGroupChosen">
    <template #selection="{ item }">
      <v-chip v-if="item && multiple" class="my-1 mr-1" close @click:close="chipClosed(item)">
        <span>{{ item.label }}</span>
      </v-chip>
      <span v-else :style="selectorSelectionTextStyle">{{ item.label }}</span>
    </template>

    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          <v-row>
            <v-col cols="auto" v-if="multiple">
              <v-icon>
                {{ getCheckboxIcon(item) }}
              </v-icon>
            </v-col>

            <v-col>
              <span>{{ item.label }}</span>
            </v-col>

            <v-col cols="auto">
              <Icon
              icon="mdi-information-outline"
              iconColor="info"
              :small="false"
              :tooltipText="`${item.lowerBound}\u0022 \u2014 ${item.upperBound}\u0022`"/>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import IconHelpers from '@/utils/IconHelpers'
import { selectorSelectionTextStyle } from '@/utils/componentHelpers'

export default {
  name: 'DiameterGroupAutocomplete',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    elementId: {
      type: String,
      required: false,
      default: 'diameter-group-autocomplete'
    },
    diameterGroups: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initSelection: {
      type: [Array, Object],
      required: false,
      default: undefined
    },
    forbidOverlap: {
      type: [Boolean, String],
      required: false,
      default: false
    }
  },

  data: () => ({
    IconHelpers,
    selectorSelectionTextStyle,
    selection: null
  }),

  computed: {
    label () {
      return this.multiple ? this.$t('diameterGroups') : this.$t('diameterGroup')
    },

    errorMessages () {
      if (!this.forbidOverlap || !this.selection) {
        return null
      }
      return this.selection.every(dg => {
        const otherGroups = this.selection.filter(other => other.diameterGroupId !== dg.diameterGroupId)
        return otherGroups.every(other => dg.lowerBound > other.upperBound || dg.upperBound < other.lowerBound)
      }) ? null : this.$t('overlappingDiameterGroups')
    }
  },

  created () {
    if (this.initSelection) {
      this.selection = this.initSelection
    } else if (this.multiple) {
      this.selection = []
    } else {
      this.selection = null
    }
  },

  watch: {
    initSelection (newVal) {
      if (this.multiple) return

      if (newVal) {
        if (newVal?.diameterGroupId === this.selection?.diameterGroupId) return
        this.selection = this.diameterGroups.find(dg => dg.diameterGroupId === newVal.diameterGroupId) || null
      } else {
        this.selection = null
      }
    }
  },

  methods: {
    diameterGroupChosen (value) {
      this.$emit('diameter-group-chosen', value)
    },

    chipClosed (item) {
      this.selection = this.selection.filter((i) => i.label !== item.label)
      this.$emit('diameter-group-chosen', this.selection)
    },

    getCheckboxIcon (item) {
      if (this.multiple) {
        return this.selection.some(i => i.label === item.label) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      } else {
        return item === this.selection ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      }
    }
  }
}
</script>
